export const GET_RMT_DATA = "[RMT] Data Get";
export const GET_RMT_DATA_SUCCESS = "[RMT] Data Get Success";
export const GET_RMT_DATA_FAIL = "[RMT] Data Get Fail";

export const UPDATE_RMT_DATA = "[RMT] Data Update";
export const UPDATE_RMT_DATA_SUCCESS = "[RMT] Data Update Success";
export const UPDATE_RMT_DATA_FAIL = "[RMT] Data Update Fail";
